<template>
    <v-col cols="12" class="pa-0 mt-2">
        <v-row class="position-relative">
            <v-img
                :src="require('@/assets/img/icons/store/new-section-tag.png')"
                max-height="44"
                width="111"
                class="new-section-tag"
            ></v-img>
            <v-col cols="auto" class="py-0 pr-0 d-none d-sm-block">
                <v-img
                    :src="require('@/assets/img/icons/store/icon-books-shadow.png')"
                    height="86"
                    width="86"
                ></v-img>
            </v-col>
            <v-col class="text-start pl-md-0 align-self-center">
                <p class="text-h6 mb-0 line-height-100 font-weight-black">{{ $t('store.articles_and_more')}}</p>
                <span class="font-weight-light d-none d-sm-block">Explora un mundo de fantasía y aprendizaje en revistas hechas para mentes curiosas y creativas.</span>
            </v-col>
        </v-row>
        <v-row class="px-3" align="top" justify="space-between">
            <v-col
                cols="12"
                class=""
                v-for="(row, h) in matrix"
                :key="'row-'+h"
            >
                <v-row
                    class="fill-height mb-1"
                    align="start"
                    justify="start"
                >
                    <v-col
                        class="customCols"
                        v-for="(book, k) in row"
                        :key="'bookP-'+k"
                    >
                        <Book :book="book" v-on:favorite="verifyFavorite" v-on:toBuy="toBuy" />
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-row
            align="center"
            justify="center"
            class="mt-5"
            v-if="!favoriteView && matrix.length>0"
        >
            <v-col cols="5" class="justify-self-end">
                <v-img
                    :src="require('../../assets/img/arrows/volver-figura.svg')"
                    elevation="0"
                    height="40px"
                    class="float-right"
                    contain
                    @click="previous"
                    v-if="currentPage > 0"
                >
                    <p class="button-next-2-text-2">{{ $t('store.previous') }}</p>
                </v-img>
            </v-col>
            <v-col cols="2" class="px-0">
                <span class="page-number">
                    {{ (currentPage + 1) }}
                </span>
                <span class="page-total-number text-nowrap">
                    {{ $t('store.of') + totalPages }}
                </span>
            </v-col>
            <v-col cols="5">
                <v-img
                    :src="require('../../assets/img/arrows/avanzar-figura.svg')"
                    elevation="0"
                    contain
                    height="40px"
                    class="float-left"                    
                    @click="next"
                    v-if="currentPage + 1 < totalPages"
                >
                    <p class="button-next-2-text-1">{{ $t('store.next') }}</p>
                </v-img>
            </v-col>
        </v-row>
    </v-col>
</template>

<script>

import { mapState } from 'vuex'
import Book from './Book.vue'
import BookService from '../../services/book'
import BookUserFavoriteService from '../../services/bookUserFavorite'

export default {
    props: {
        favoriteView: { type: Boolean, default: false },
        reload: { type: Number, default: 0 },
        search: { type: String, default: '' }
    },
    components: {
        Book
    },
    data() {
        return {
            books: [],
            currentPage: 0,
            favorites: [],
            totalPages: 0
        }
    },
    computed: {
        ...mapState({
            user: (state) => state.userData.user
        }),
        matrix() {
            if (!this.books) {
                return this.listToMatrix([], 1)
            }
            const books = this.books.filter( (item) => {
                return item.title.includes(this.search) || item.price.toString().includes(this.search)
            })
            if (this.$vuetify.breakpoint.xs) {
                return this.listToMatrix(books, 3)
            }
            if (this.$vuetify.breakpoint.sm) {
                return this.listToMatrix(books, 3)
            }
            if (this.$vuetify.breakpoint.md) {
                return this.listToMatrix(books, 4)
            }
            if (this.$vuetify.breakpoint.lg) {
                return this.listToMatrix(books, 5)
            }
            if (this.$vuetify.breakpoint.xl) {
                return this.listToMatrix(books, 5)
            }
            return this.listToMatrix(books, 4)
        }
    },
    mounted() {
        this.loadData()
    },
    methods: {
        getFavorites() {
            this.$emit('loaded', false)
            this.books = null
            this.favorites = []
            BookUserFavoriteService.getFavoriteBooksByUser(
                this.user.id
            )
            .then((response) => {
                this.books = response.content
                this.favorites = response.content.map(
                    favotite =>  ({id: favotite.id, title: favotite.title })
                )
                this.$emit('loaded', true)
            })
            .catch((error) => console.error(error))
        },
        getUserPayBooks() {
            this.$emit('loaded', false)
            this.books = null
            BookService.getAllPayBookByUser(
                this.user.id,
                this.currentPage,
                15
            )
            .then((response) => {
                this.books = response.content.content.reverse()
                this.totalPages = response.content.totalPages
                this.$emit('loaded', true)
            })
            .catch((error) => console.error(error))
        },
        listToMatrix(list, elementsPerSubArray) {
            const matrix = []
            let i
            let k

            for (i = 0, k = -1; i < list.length; i+=1) {
                if (i % elementsPerSubArray === 0) {
                    k+=1;
                    matrix[k] = [];
                }
                matrix[k].push(list[i])
            }
            return matrix
        },
        async loadData() {
            if (this.favoriteView) {
                await this.getFavorites()
            } else {
                await this.getUserPayBooks()
            }
        },
        verifyFavorite(data) {
            const currentFavorites = JSON.parse(JSON.stringify(this.favorites))
            this.favorites = []
            setTimeout(() => {
                this.filterFavorite(data, currentFavorites)
            }, 500)
        },
        filterFavorite(data, currentFavorites) {
            const favorites = currentFavorites
            if (data.favorite) {
                favorites.push( { id: data.id } )
                this.favorites = favorites
            } else {
                this.favorites = favorites.filter( (item) => item.id !== data.id )
            }
        },
        next() {
            if (this.currentPage < (this.totalPages - 1)) {
                this.currentPage += 1
                this.books = []
                this.loadData()
            }
        },
        previous() {
            if (this.currentPage > 0) {
                this.currentPage -= 1
                this.books = []
                this.loadData()
            }
        },
        toBuy (book) {
            this.books.forEach((bookInList) => {
                if (bookInList.id === book.id) {
                    this.$emit('purchase', book)
                }
            })
        }
    },
    watch: {
        reload() {
            this.loadData()
        }
    }
}
</script>
<style scoped>
.customCols {
    width: 33%;
    max-width: 33%;
    flex-basis: 33%;
    padding-left: 0;
    padding-right: 0;
}
@media (min-width: 600px) {
    .customCols {
        width: 33%;
        max-width: 33%;
        flex-basis: 33%;
    }
}
@media (min-width: 960px) {
    .customCols {
        width: 25%;
        max-width: 25%;
        flex-basis: 25%;
    }
}
@media (min-width: 1264px) {
    .customCols {
        width: 20%;
        max-width: 20%;
        flex-basis: 20%;
    }
}
@media (min-width: 1904px) {
    .customCols {
        width: 20%;
        max-width: 20%;
        flex-basis: 20%;
    }
}

.button-next-2-text-1 {
    color: white;
    font-size: 1em;
    height: 100%;
    line-height: 40px;
}
.button-next-2-text-2 {
    color: #514585;
    font-size: 1em;
    height: 100%;
    line-height: 40px;
    margin-bottom: 0;
}
.page-number {
    font-size: 1em;
}
.page-total-number {
    color: #51458596;
    font-size: 1em;
}
.new-section-tag{
    position: absolute;
    top: -1em;
    left: 0px;
}
/* @media (max-width: 1263px) {
    .button-next-2-text-1 {
        font-size: 3vw;
    }
    .button-next-2-text-2 {
        font-size: 3vw;
    }
    .page-number {
        font-size: 3vw;
    }
    .page-total-number {
        font-size: 3vw;
    }
} */
</style>
